module.exports = __webpack_public_path__ + "img/04-B03.3a859d75.png";